"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _index = _interopRequireDefault(require("./index.style"));
const Footer = props => {
  const classes = (0, _index.default)();
  const {
    children,
    className,
    ...others
  } = props;
  return /*#__PURE__*/_react.default.createElement("footer", (0, _extends2.default)({
    className: (0, _clsx.default)(classes.root, className)
  }, others), children);
};
var _default = exports.default = Footer;